import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Category, CategoryService, CreateCategoryInput, UpdateCategoryInput } from "../services/categoryService";

export const useCategory = (categoryId: string) => {
  return useQuery({
    queryKey: ["category", categoryId],
    queryFn: () => CategoryService.getCategoryById(categoryId),
  });
};

export const useCategories = () => {
  const queryClient = useQueryClient();

  const {
    data: categories,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["categories"],
    queryFn: async () => {
      console.log("Fetching categories...");
      try {
        const result = await CategoryService.getAllCategories();
        console.log("Categories fetched successfully:", result);
        return result;
      } catch (error) {
        console.error("Error fetching categories:", error);
        throw error;
      }
    },
  });

  const createCategory = useMutation({
    mutationFn: (category: CreateCategoryInput) => CategoryService.createCategory(category),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["categories"] });
    },
  });

  const updateCategory = useMutation({
    mutationFn: ({ id, category }: { id: string; category: UpdateCategoryInput }) => CategoryService.updateCategory(id, category),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["categories"] });
    },
  });

  const deleteCategory = useMutation({
    mutationFn: (id: string) => CategoryService.deleteCategory(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["categories"] });
    },
  });

  const uploadCategoryImage = useMutation({
    mutationFn: (file: File) => CategoryService.uploadCategoryImage(file),
  });

  return {
    categories,
    isLoading,
    error,
    createCategory,
    updateCategory,
    deleteCategory,
    uploadCategoryImage,
  };
};
